import httpClient from '../../api/axios-httpclient';
import VersionFeatureAPI from '@/api/VersionFeatureAPI.js';
import commonFunc from '@/common/commonFunction';
export default {
	getVersionFeatures: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: VersionFeatureAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/pagingsearch`,
			data: payload
		});
		if (res && res.Data) {
			if (payload.appendData) {
				context.commit('appendVersionFeatures', res.Data);
			} else {
				context.commit('updateVersionFeatures', res.Data);
			}
			return res.Data;
		}
		return res;
	},

	getTotalVersionFeatures: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: VersionFeatureAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			data: payload
		});
		if (res && res.Success) {
			context.commit('updateTotalVersionFeatures', res.Data);
			return res.Data;
		}
		return 0;
	},

	updateNumberView: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: VersionFeatureAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/updatenumberview`,
			data: payload
		});
		return res;
	}
};
